/**
 * @description Format number theo định dạng
 * @param {*} value Giá trị
 * @param {*} decimalLength Số chữ số thập phân
 * @param {*} partLength Số lượng chữ số từng phần (group)
 * @param {*} sectionDelimiter Dấu phân cách giữa các group
 * @param {*} decimalDelimiter Dấu chữ số thập phân
 * @returns
 * @author PHNam
 */
const formatNumber = function (value, decimalLength, partLength, sectionDelimiter, decimalDelimiter) {
  if (typeof value === 'string') {
    const regex = /^-?\d+\.?\d*$/

    if (regex.test(value)) { value = Number.parseFloat(value) }
  }

  if (typeof value !== 'number') { return false }

  const regex = '\\d(?=(\\d{' + (partLength || 3) + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')'
  const num = value.toFixed(Math.max(0, ~~decimalLength))

  return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(regex, 'g'), '$&' + (sectionDelimiter || ','))
}

export { formatNumber }
